<template>
  <div>
    <section id="last-work" class="cr-section about-area section-padding-xlg bg-image-4" data-white-overlay="9.5">
      <div class="section fp-section" data-anchor="fifth-section">
          <div class="container">
            <div class="row justify-content-between" v-if="gallery">
              <div  class="testimonial text-center">
                <h1 >{{gallery.name}}</h1>
                <p>{{gallery.description}}</p>
                <span  class="testimonial-border-topleft"></span>
                <span  class="testimonial-border-topright"></span>
                <span  class="testimonial-border-bottomleft"></span>
                <span  class="testimonial-border-bottomright"></span>
              </div>
              <CoolLightBox v-if="items && items.length"
                :items="items"
                :index="index"
                @close="index = null">
              </CoolLightBox>
              <div class="images-wrapper">
                <div class="d-flex flex-row flex-wrap justify-content-center">
                  <!-- Single Portfolio -->
                  <div class="d-flex flex-column ">
                  <template v-for="(image,ind) in items">
                    <div v-if="ind%3 === 0" class="portfolio-item portfolio-filter-graphic portfolio-filter-design"  v-bind:key="'galleryimg--'+ind">
                      <div class="portfolio">
                        <div class="portfolio-image">
                          <ImageLazy :image="image.src" :alt="image.description" :title="image.title"  class-name="" :key="ind"></ImageLazy>
                        </div>
                        <div class="portfolio-content"   @click="index = ind">
                          <h5>{{image.title}}</h5>
                        </div>
                      </div>
                    </div>
                  </template>
                    </div>
                  <div class="d-flex flex-column ">
                  <!-- Single Portfolio -->
                  <template v-for="(image,ind) in items">
                    <div v-if="ind%3 === 1" class=" portfolio-item portfolio-filter-graphic portfolio-filter-design"  v-bind:key="'galleryimg--'+ind">
                      <div class="portfolio">
                        <div class="portfolio-image">
                          <ImageLazy :image="image.src" :alt="image.description" :title="image.title"  class-name="" :key="ind"></ImageLazy>
                        </div>
                        <div class="portfolio-content"   @click="index = ind">
                          <h5>{{image.title}}</h5>
                        </div>
                      </div>
                    </div>
                  </template>
                  </div>
                  <div class="d-flex flex-column ">
                  <template v-for="(image,ind) in items">
                    <div v-if="ind%3 === 2" class=" portfolio-item portfolio-filter-graphic portfolio-filter-design"  v-bind:key="'galleryimg--'+ind">
                      <div class="portfolio">
                        <div class="portfolio-image">
                          <ImageLazy :image="image.src" :alt="image.description" :title="image.title"  class-name="" :key="ind"></ImageLazy>
                        </div>
                        <div class="portfolio-content"   @click="index = ind">
                          <h5>{{image.title}}</h5>
                        </div>
                      </div>
                    </div>
                  </template>
                    </div>
                 <!-- <div class="d-flex flex-column ">
                    <template v-for="(image,ind) in items">
                      <div v-if="ind%4 === 0" class=" portfolio-item portfolio-filter-graphic portfolio-filter-design"  v-bind:key="'galleryimg--'+ind">
                        <div class="portfolio">
                          <div class="portfolio-image">
                            <ImageLazy :image="image.src" :alt="image.description" :title="image.title"  class-name="" :key="ind"></ImageLazy>
                          </div>
                          <div class="portfolio-content"   @click="index = ind">
                            <h5>{{image.title}}</h5>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>-->
                </div>
              </div>
              </div>
            </div>
          </div>
    </section>
  </div>
</template>

<script>
import ImageLazy from '../ImageLazy'
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

export default {
  name: 'GalleryPage',
  components: {
    ImageLazy,
    CoolLightBox
  },
  data () {
    return {
      index: null,
      items: [],
      gallery: null,
      loaded: false
    }
  },
  mounted () {
    this.getGallery()
    const self = this
    self.$eventHub.$on('language-changed', function () {
      self.getGallery()
    })
  },
  methods: {
    getGallery () {
      this.axios.get(this.$host + 'gallery/' + this.$route.params.slug).then(resp => {
        this.gallery = resp.data.data
        document.title = resp.data.data.name
        this.items = []
        this.gallery.images.forEach(item => {
          this.items.push({
            title: item.title,
            description: item.description,
            src: item.image
          })
        })
        this.loaded = true
      }).catch(() => {
        this.loaded = true
        this.$router.push('/404')
      })
    }
  }
}
</script>

<style scoped>

.flex-column {
  max-width: 33%;
  width: 33%;
}
@media screen and (max-width: 800px) {
  .flex-column {
    flex: 50%;
    max-width: 50%;
  }
}

/* Responsive layout - makes the two columns stack on top of each other instead of next to each other */
@media screen and (max-width: 600px) {
  .flex-column {
    flex: 100%;
    max-width: 100%;
  }
}

.portfolio-item.portfolio-filter-graphic.portfolio-filter-design {
  margin: 4px !important;
}
.portfolio {
  margin: 4px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/gallery/GalleryPage.vue